import $http from "../axios";

const state = {};

const getters = {};

const actions = {
  getVendings() {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-vendings`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
